import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::index
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:30
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}'
*/
export const index = (args: { taxonomy: string | number } | [taxonomy: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '//org.launchstation.app/blog/taxonomy/{taxonomy}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::index
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:30
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}'
*/
index.url = (args: { taxonomy: string | number } | [taxonomy: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { taxonomy: args }
    }

    if (Array.isArray(args)) {
        args = {
            taxonomy: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        taxonomy: args.taxonomy,
    }

    return index.definition.url
            .replace('{taxonomy}', parsedArgs.taxonomy.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::index
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:30
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}'
*/
index.get = (args: { taxonomy: string | number } | [taxonomy: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::index
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:30
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}'
*/
index.head = (args: { taxonomy: string | number } | [taxonomy: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::index
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:30
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}'
*/
const indexForm = (args: { taxonomy: string | number } | [taxonomy: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::index
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:30
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}'
*/
indexForm.get = (args: { taxonomy: string | number } | [taxonomy: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::index
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:30
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}'
*/
indexForm.head = (args: { taxonomy: string | number } | [taxonomy: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::create
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:40
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}/create'
*/
export const create = (args: { taxonomy: string | number } | [taxonomy: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(args, options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '//org.launchstation.app/blog/taxonomy/{taxonomy}/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::create
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:40
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}/create'
*/
create.url = (args: { taxonomy: string | number } | [taxonomy: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { taxonomy: args }
    }

    if (Array.isArray(args)) {
        args = {
            taxonomy: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        taxonomy: args.taxonomy,
    }

    return create.definition.url
            .replace('{taxonomy}', parsedArgs.taxonomy.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::create
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:40
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}/create'
*/
create.get = (args: { taxonomy: string | number } | [taxonomy: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::create
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:40
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}/create'
*/
create.head = (args: { taxonomy: string | number } | [taxonomy: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(args, options),
    method: 'head',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::create
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:40
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}/create'
*/
const createForm = (args: { taxonomy: string | number } | [taxonomy: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::create
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:40
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}/create'
*/
createForm.get = (args: { taxonomy: string | number } | [taxonomy: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::create
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:40
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}/create'
*/
createForm.head = (args: { taxonomy: string | number } | [taxonomy: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::store
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:58
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}'
*/
export const store = (args: { taxonomy: string | number } | [taxonomy: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '//org.launchstation.app/blog/taxonomy/{taxonomy}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::store
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:58
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}'
*/
store.url = (args: { taxonomy: string | number } | [taxonomy: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { taxonomy: args }
    }

    if (Array.isArray(args)) {
        args = {
            taxonomy: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        taxonomy: args.taxonomy,
    }

    return store.definition.url
            .replace('{taxonomy}', parsedArgs.taxonomy.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::store
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:58
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}'
*/
store.post = (args: { taxonomy: string | number } | [taxonomy: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::store
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:58
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}'
*/
const storeForm = (args: { taxonomy: string | number } | [taxonomy: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::store
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:58
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}'
*/
storeForm.post = (args: { taxonomy: string | number } | [taxonomy: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::edit
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:47
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}/{id}/edit'
*/
export const edit = (args: { taxonomy: string | number, id: string | number } | [taxonomy: string | number, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '//org.launchstation.app/blog/taxonomy/{taxonomy}/{id}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::edit
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:47
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}/{id}/edit'
*/
edit.url = (args: { taxonomy: string | number, id: string | number } | [taxonomy: string | number, id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            taxonomy: args[0],
            id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        taxonomy: args.taxonomy,
        id: args.id,
    }

    return edit.definition.url
            .replace('{taxonomy}', parsedArgs.taxonomy.toString())
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::edit
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:47
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}/{id}/edit'
*/
edit.get = (args: { taxonomy: string | number, id: string | number } | [taxonomy: string | number, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::edit
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:47
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}/{id}/edit'
*/
edit.head = (args: { taxonomy: string | number, id: string | number } | [taxonomy: string | number, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::edit
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:47
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}/{id}/edit'
*/
const editForm = (args: { taxonomy: string | number, id: string | number } | [taxonomy: string | number, id: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::edit
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:47
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}/{id}/edit'
*/
editForm.get = (args: { taxonomy: string | number, id: string | number } | [taxonomy: string | number, id: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::edit
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:47
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}/{id}/edit'
*/
editForm.head = (args: { taxonomy: string | number, id: string | number } | [taxonomy: string | number, id: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::update
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:70
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}/{id}'
*/
export const update = (args: { taxonomy: string | number, id: string | number } | [taxonomy: string | number, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '//org.launchstation.app/blog/taxonomy/{taxonomy}/{id}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::update
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:70
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}/{id}'
*/
update.url = (args: { taxonomy: string | number, id: string | number } | [taxonomy: string | number, id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            taxonomy: args[0],
            id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        taxonomy: args.taxonomy,
        id: args.id,
    }

    return update.definition.url
            .replace('{taxonomy}', parsedArgs.taxonomy.toString())
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::update
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:70
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}/{id}'
*/
update.patch = (args: { taxonomy: string | number, id: string | number } | [taxonomy: string | number, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::update
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:70
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}/{id}'
*/
const updateForm = (args: { taxonomy: string | number, id: string | number } | [taxonomy: string | number, id: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::update
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:70
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}/{id}'
*/
updateForm.patch = (args: { taxonomy: string | number, id: string | number } | [taxonomy: string | number, id: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::destroy
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:89
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}/{id}'
*/
export const destroy = (args: { taxonomy: string | number, id: string | number } | [taxonomy: string | number, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '//org.launchstation.app/blog/taxonomy/{taxonomy}/{id}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::destroy
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:89
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}/{id}'
*/
destroy.url = (args: { taxonomy: string | number, id: string | number } | [taxonomy: string | number, id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            taxonomy: args[0],
            id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        taxonomy: args.taxonomy,
        id: args.id,
    }

    return destroy.definition.url
            .replace('{taxonomy}', parsedArgs.taxonomy.toString())
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::destroy
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:89
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}/{id}'
*/
destroy.delete = (args: { taxonomy: string | number, id: string | number } | [taxonomy: string | number, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::destroy
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:89
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}/{id}'
*/
const destroyForm = (args: { taxonomy: string | number, id: string | number } | [taxonomy: string | number, id: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\TaxonomyController::destroy
* @see app/Domain/Blog/Http/Controllers/Admin/TaxonomyController.php:89
* @route '//org.launchstation.app/blog/taxonomy/{taxonomy}/{id}'
*/
destroyForm.delete = (args: { taxonomy: string | number, id: string | number } | [taxonomy: string | number, id: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const taxonomy = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default taxonomy